import React, {Component} from 'react';
import * as R from 'ramda';

import ConfigurableStar from 'js/components/configurable_star';
import Rate from 'js/components/rate';
import FeedbackPanel from 'js/components/feedback_panel';

import './index.scss';

export default class RejectionRestrictedApprovedFeedback extends Component {
    static defaultProps = {
        onRating: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            rating: props.rating
        };
    }

    onRating = (rating) => {
        const {onRating} = this.props;
        this.setState({rating});
        onRating(rating);
    };

    revert = () => {
        const {onCancel, onPrevious} = this.props;

        onCancel();
        onPrevious();
    };

    render() {
        const {onNext, isTransmitting} = this.props;

        const {rating} = this.state;

        return (
            <FeedbackPanel
                heading="Hooray! The creator has been notified to post"
                subheading="Content Rating"
                onCancel={this.revert}
                onSubmit={onNext}
                submitDisabled={R.isNil(rating) || isTransmitting}
                sameSizeButtons={false}
                submitButtonCopy={'Submit & Continue'}
            >
                <Rate items={5} icon={ConfigurableStar} onRating={this.onRating} />
            </FeedbackPanel>
        );
    }
}



// WEBPACK FOOTER //
// ./components/content_review_workflow/rejection_restricted_path/rejection_restricted_approved_feedback/index.js